/* This file is autogenerated by @oui/cli */
import Svg, { Circle, Path, Rect, type SvgProps } from 'react-native-svg';

const SvgComponent = (props: SvgProps) => (
  <Svg width={18} height={18} viewBox="0 0 18 18" fill="none" {...props}>
    <Rect
      x={1}
      y={1}
      width={16}
      height={16}
      rx={3}
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      vectorEffect="non-scaling-stroke"
    />
    <Circle cx={4.98} cy={6.71} r={0.84} fill="currentColor" stroke="currentColor" />
    <Circle cx={13.01} cy={6.71} r={0.84} fill="currentColor" stroke="currentColor" />
    <Path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.06 12.46c2.79.06 4.17-.88 4.17-.88s-.93 2.87-4.2 2.8c-3.27-.07-4.2-2.98-4.2-2.98s1.33.99 4.23 1.05v.01Z"
      fill="currentColor"
    />
  </Svg>
);
export default SvgComponent;
